import { useEffect, useRef } from 'react'

export const newOperation = ({
  operation_id,
  data_room_display_name,
  data_room,
  stage_label = 'Operation starting',
}) => {
  return {
    operation_id,
    data_room,
    data_room_display_name,
    stage: 0,
    stage_label,
    number_files: 0,
    number_files_skipped: 0,
    number_files_sw: 0,
    number_files_redacting: 0,
    number_folders: 0,
    number_questions: 0,
    number_logs: 0,
    size: 0,
    size_dl: 0,
    file: null,
    file_name: null,
  }
}

export const updateOperation = (operation, data) => {
  if (operation == null) {
    return
  }

  if (data.stage && data.stage >= operation.stage) {
    operation.stage = data.stage
    if (data.stage_label) {
      operation.stage_label = data.stage_label
    }
  }

  if (operation.stage < 100) {
    if (data.add_number_files) {
      operation.number_files += data.add_number_files
    }
    if (data.add_number_folders) {
      operation.number_folders += data.add_number_folders
    }
    if (data.add_number_questions) {
      operation.number_questions += data.add_number_questions
    }
    if (data.add_number_logs) {
      operation.number_logs += data.add_number_logs
    }
    if (data.add_size) {
      operation.size += data.add_size
    }
    if (data.add_size_dl) {
      operation.size_dl += data.add_size_dl
    }
  }

  if (data.file) {
    operation.file = data.file
  }
  if (data.file_name) {
    operation.file_name = data.file_name
  }
  if (data.download_link) {
    operation.download_link = data.download_link
  }
  if (typeof data.number_files !== 'undefined') {
    operation.number_files = data.number_files
  }
  if (typeof data.number_files_skipped !== 'undefined') {
    operation.number_files_skipped = data.number_files_skipped
  }
  if (typeof data.number_files_sw !== 'undefined') {
    operation.number_files_sw = data.number_files_sw
  }
  if (typeof data.number_files_redacting !== 'undefined') {
    operation.number_files_redacting = data.number_files_redacting
  }
  if (typeof data.number_folders !== 'undefined') {
    operation.number_folders = data.number_folders
  }
  if (typeof data.size !== 'undefined') {
    operation.size = data.size
  }
  if (data.warn_long_paths != null) {
    operation.warn_long_paths = data.warn_long_paths
  }

  if (operation.stage === 100) {
    if (data.download_link) {
      window.location = data.download_link // Trigger file download
    }
  }

  return operation
}

export const padNumbers = function(strIn) {
  if (!strIn) {
    return strIn
  }

  let out = ''
  let strSplit = strIn.split(/(\d+)/g)

  for (let i = 0; i < strSplit.length; i++) {
    if (strSplit[i]) {
      if (isNaN(strSplit[i])) {
        out += strSplit[i]
      } else {
        out += strSplit[i].padStart(10, '0')
      }
    }
  }

  return out
}

export const useIsMounted = function() {
  const isMountedRef = useRef()
  useEffect(() => {
    isMountedRef.current = true
    return () => isMountedRef.current = false
  })
  return isMountedRef
}

export const timeout = function (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const setModes = async function (setMode, modes) {
  for (let x of modes) {
    if (typeof x === 'string' || x instanceof String) {
      setMode(x)
    } else {
      await timeout(x)
    }
  }
}
